import { getYearByMonth } from "./getYearByMonth"
import { t } from "i18next";

export const getSubscriptionTitle = (period: number): string => (getYearByMonth(period) >= 1) ? t(
    "subscription:FIRST_PAGE.SUBSCRIPTION_CHOICE.SUBSCRIPTION_TITLE",
    { count: getYearByMonth(period) }
) : t("subscription:FIRST_PAGE.SUBSCRIPTION_CHOICE.SUBSCRIPTION_TITLE_MONTHLY");

export function getCarouselSubscriptionTitle(period: number): string {
    if (period >= 12) {
        const asYears = getYearByMonth(period);
        return t(`subscriptioncarousel:CARDSBLOCK_${asYears}YEAR${asYears === 1 ? '' : 'S'}_TITLE`);
    }
    return t('subscriptioncarousel:CARDSBLOCK_MONTHLY_TITLE');
}

export function getCarouselSubscriptionPaymentDescription(period: number, price: string): string {
    if (period >= 12) {
        const asYears = getYearByMonth(period);
        return t(`subscriptioncarousel:CARDSBLOCK_${asYears}YEAR${asYears === 1 ? '' : 'S'}_PAYMENT`, { total_price: price });
    }
    return t('subscriptioncarousel:CARDSBLOCK_MONTHLY_PAYMENT', { total_price: price });
}